import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '24',
  height: '21',
  viewBox: '0 0 24 21'
}, [
  h('path', {
    d: 'M11.5 21h-.2l-11-5c-.2-.1-.3-.3-.3-.5v-8c0-.2.1-.3.2-.4S.6 7 .7 7l11 5c.2.1.3.3.3.5v8c0 .2-.1.3-.2.4-.1.1-.2.1-.3.1zM1 15.2l10 4.5v-6.9L1 8.3v6.9z'
  }),
  h('path', {
    d: 'M11.5 21c-.1 0-.2 0-.3-.1-.1-.1-.2-.2-.2-.4v-8c0-.2.1-.4.3-.5l12-5c.2-.1.3 0 .5 0 .1.2.2.3.2.5v8c0 .2-.1.4-.3.5l-12 5h-.2zm.5-8.2v6.9l11-4.6V8.2l-11 4.6zM12 10c-2 0-3.5-.9-3.5-2S10 6 12 6s3.5.9 3.5 2-1.5 2-3.5 2zm0-3c-1.5 0-2.5.6-2.5 1s1 1 2.5 1 2.5-.6 2.5-1-1-1-2.5-1zM12 4.5c-2 0-3.5-.9-3.5-2s1.5-2 3.5-2 3.5.9 3.5 2-1.5 2-3.5 2zm0-3c-1.5 0-2.5.6-2.5 1s1 1 2.5 1 2.5-.6 2.5-1-1-1-2.5-1zM19 7.5c-2 0-3.5-.9-3.5-2s1.5-2 3.5-2 3.5.9 3.5 2-1.5 2-3.5 2zm0-3c-1.5 0-2.5.6-2.5 1s1 1 2.5 1 2.5-.6 2.5-1-1-1-2.5-1zM5.5 7.5c-2 0-3.5-.9-3.5-2s1.5-2 3.5-2 3.5.9 3.5 2-1.5 2-3.5 2zm0-3C4 4.5 3 5.1 3 5.5s1 1 2.5 1S8 5.9 8 5.5s-1-1-2.5-1z'
  }),
  h('path', {
    d: 'M.5 8c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.7l2.6-1.1c.3-.1.5 0 .7.3s0 .5-.3.7L.7 8H.5zM7.6 4.9c-.2 0-.4-.1-.5-.3-.1-.2 0-.5.3-.6l2.1-1c.3-.1.5 0 .7.3.1.3 0 .5-.3.7l-2.1.9h-.2zM16.7 5h-.2l-2.4-1.1c-.3-.1-.4-.4-.3-.7.1-.2.4-.3.7-.2l2.4 1.1c.3.1.4.4.3.7-.1.1-.3.2-.5.2zM23.5 8h-.2L21 7c-.3-.1-.4-.4-.3-.7.2-.3.4-.4.7-.3l2.3 1c.3.2.4.4.3.7-.1.2-.3.3-.5.3z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-ct.es6.js